<template>
  <div :id="id" class="top-bar" style="">
    <div :style="{'background-color':color}" class="icon">
      <span :class="{en: language === 'ch' ? true : false}">{{text}}</span>
    </div>
    <span v-if="data.navType == 5" style="float: right;font-size: 14px;cursor: pointer;" :style="{color: color}" @click="more">{{ $t("message.more") }}》</span>
  </div>
</template>
<script>
export default{
    data(){
      return {
        language: 'ch'
      }
    },
    props: {
      text:{
          type:String,
          default:"基本信息"
      },
      id:{
          type: String
      },
      data:{
        type: Object,
        default: {}
      },
      color:{
        type: String,
        default:()=>{
          return 'rgb(243, 152, 0)'
        }
      }
    },
    computed:{
    },
    methods: {
      more(){
        const url = location.origin+ '/webpc/live/'+ this.$route.params.cid
        window.open(url)
      },
    },
    created(){

    },
    mounted(){
      this.language = localStorage.getItem('locale')
    }
}
</script>
<style lang="scss" scoped>
  .top-bar{
    /* display: flex; */
    /* width: 90px; */
    font-size: 15px;
    align-items: center;
    color: #121212;
    /*font-weight: 600;*/
    margin-top: 30px;
    margin-bottom: 20px;
    border-bottom: 1px solid #d3d3d3;
    font-size: 0;
  }
  .icon{
    position: relative;
    line-height: 28px;
    color: #ffffff;
    display: inline-block;
    background-color: #00c261;
    font-size: 14px;
    /*font-weight: 700;*/

  }
  .icon span{
    width: 240px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    display: block;
    text-align: center;
    padding: 0 10px;
    font-size: 12px;
    &.en{
      font-size: 14px;
      width: 180px;
    }
  }
  .icon:after {
       display: block;
       content: "";
       position: absolute;
       border: 6px solid #dcdcdc;
       border-left-color: transparent;
       border-top-color: transparent;
       right: 0;
       bottom: 0;
     }
  .icon:before {
    display: block;
    content: "";
    position: absolute;
    border: 6px solid #dcdcdc;
    border-right-color: transparent;
    border-bottom-color: transparent;
    left: 0;
    top: 0;
  }
</style>



// WEBPACK FOOTER //
// topBar.vue?7aff34b8